import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { API_BASE } from '../config';

function CodeRedemptionModal({ isOpen, onClose, onSuccess }) {
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);

    const [stripeEnabled, setStripeEnabled] = useState(false);
    const [paying, setPaying] = useState(false);

    useEffect(() => {
        if (!isOpen) return;
        fetch(`${API_BASE}/api/payments/config`)
            .then(r => r.ok ? r.json() : null)
            .then(d => setStripeEnabled(!!(d && d.stripe_enabled)))
            .catch(() => setStripeEnabled(false));
    }, [isOpen]);

    const handleOnlinePay = async () => {
        setPaying(true);
        try {
            const response = await fetch(`${API_BASE}/api/payments/stripe/checkout`, { method: 'POST' });
            if (!response.ok) throw new Error('checkout failed');
            const data = await response.json();
            window.location.href = data.url;
        } catch (error) {
            console.error('在线支付发起失败:', error);
            toast.error('在线支付暂时不可用，请改用购买兑换码');
            setPaying(false);
        }
    };

    const handlePurchase = () => {
        // 跳转到外部购买链接
        window.open('https://www.dtjishou.net/item/s0devq', '_blank');
    };

    const handleVerify = async () => {
        if (!code.trim()) {
            toast.error('请输入兑换码');
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(`${API_BASE}/api/redemption-codes/verify`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code: code.trim() })
            });

            if (response.ok) {
                const result = await response.json();
                toast.success('兑换码验证成功！');
                onSuccess(code.trim()); // 验证成功，传递兑换码给父组件
                onClose();
            } else {
                const error = await response.json();
                toast.error(error.detail || '兑换码无效或已使用');
            }
        } catch (error) {
            console.error('验证失败:', error);
            toast.error('验证失败，请重试');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-ink/50 flex items-center justify-center z-50">
            <div className="bg-paper-card border border-line rounded shadow-2xl p-6 w-96 max-w-[90vw]">
                <h3 className="text-xl font-serif font-bold text-ink mb-4 text-center tracking-widest">获取完整报告</h3>

                <p className="text-center text-ink-soft text-sm mb-4">
                    完整报告 <span className="text-lg font-bold text-primary-600">¥99</span> / 份（含运势预测与 30 问答疑）
                </p>

                <ol className="text-left text-sm text-ink-soft mb-4 space-y-1.5 list-decimal list-inside">
                    <li>在线支付（推荐）：点下方“在线支付”，付完自动进入报告，无需输码。</li>
                    <li>或点“购买兑换码”前往第三方卖码站购码，再回到下方输入兑换码开始探索。</li>
                </ol>
                <p className="text-xs text-ink-faint mb-4">
                    在线支付由 Stripe 安全处理；每个兑换码仅可使用一次，验证成功即绑定本次报告。卖码站的付款问题请先联系卖码站客服。
                </p>

                {stripeEnabled && (
                    <button
                        onClick={handleOnlinePay}
                        disabled={paying}
                        className="w-full bg-primary-600 hover:bg-primary-700 text-paper-card py-3 rounded mb-3 disabled:opacity-50 transition-colors font-medium"
                    >
                        {paying ? '正在跳转到支付页...' : '在线支付 ¥99（支付宝 / 银行卡）'}
                    </button>
                )}

                <button
                    onClick={handlePurchase}
                    className="w-full bg-accent-500 hover:bg-accent-600 text-paper-card py-3 rounded mb-4 transition-colors font-medium"
                >
                    购买兑换码
                </button>

                <div className="mb-4">
                    <label className="form-label">兑换码</label>
                    <input
                        type="text"
                        placeholder="请输入兑换码"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        className="form-input"
                        maxLength={20}
                    />
                </div>

                <button
                    onClick={handleVerify}
                    disabled={loading || !code.trim()}
                    className="w-full bg-primary-600 hover:bg-primary-700 text-paper-card py-3 rounded mb-3 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-medium"
                >
                    {loading ? '验证中...' : '开始探索'}
                </button>

                <p className="text-xs text-ink-faint text-center mb-3">
                    售后联系：TODO（待填写客服邮箱，由站长在上线前填入；兑换码无效、已使用或报告生成失败请凭订单号联系）。
                </p>

                <button
                    onClick={onClose}
                    className="w-full bg-paper-deep hover:bg-line text-ink-soft py-2 rounded transition-colors"
                >
                    取消
                </button>
            </div>
        </div>
    );
}

export default CodeRedemptionModal;
